const styles = {
  main: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    marginTop: 1,
  },
  icon: {
    marginLeft: 0.5,
  },
}

export default styles
